import React, { memo } from 'react';
import style from './NevisPasskeysNoItem.scss';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';

export const NevisPasskeysListContainer: React.FC<{
    tkPrefix?: string;
    values: string[];
    t: ITranslateMethod;
}> = memo(({ tkPrefix, values, t }) => (
    <div className={style.listContainer}>
        <ul className={style.noListStyle}>
            {values?.map((value, index) =>
                <li className={style.titleList}
                    key={index}>
                    {t(`${tkPrefix}noPasskeys.${value}.title`)}
                    <span>{t(`${tkPrefix}noPasskeys.${value}.explanation`)}</span>
                </li>
            )}
        </ul>
    </div>
));
